import { PimWeightMetricValueV1UnitEnum } from '@redteclab/api/clients/bully'
import { number, oneOf, shape, string } from 'prop-types'

export const PimProductCarbonFootprintType = shape({
  total_avg: shape({
    amount: number.isRequired,
    formatted: string.isRequired,
    unit: oneOf(Object.values(PimWeightMetricValueV1UnitEnum)).isRequired,
  }).isRequired,
})
